import { PropsWithChildren } from "react";

import styles from "./Banner.module.scss";

export const Banner = ({ children }: PropsWithChildren) => {
  return (
    <div className={styles.banner}>
      <div className={styles.banner__info}>{children}</div>
    </div>
  );
};
